<template>
  <div class="page" id="addPage">
    <PageHeader :links="headLinks" />
    <div class="pageMain" ref="pageMain">
      <el-row>
        <el-col :span="24" finish-status="success" align-center="true">
          <el-steps :active="0" finish-status="success" style="margin: 30px">
            <el-step v-for="item in steps" :title="item.name" :status="item.status" :key="item.name"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <!--投稿须知-->
      <el-row v-show="step == 0">
        <div class="box" style="margin-bottom: 0">
          <div class="header">
            <h3>投稿须知</h3>
          </div>
          <div class="content">
            <div style="line-height: 180%" v-html="noticeHtml"></div>
          </div>
        </div>

        <div class="box" v-if="times > 0" id="djs" style="margin-top: 0; margin-bottom: 0; text-align: center">
          阅读倒计时 <span style="font-size: 20px; color: coral">{{ times }}</span> 秒
        </div>

        <div class="box" v-if="times <= 0"
          style="display: flex; margin-top: 0; justify-content: center; align-items: center; padding: 15px 0">
          <el-checkbox v-model="checked">接受该须知</el-checkbox> &nbsp;&nbsp;&nbsp;&nbsp;
          <el-button type="primary" size="large" @click="gotoStep(1, false)">我已详细阅读须知</el-button>
        </div>
      </el-row>

      <!--投稿表单-->
      <el-row v-show="step == 1">
        <div ref="addBox" class="box" style="padding: 0; margin: 0 30px; border: none">
          <div class="content">
            <el-row>
              <el-col :lg="{ span: 24 }" :xl="{ span: 16 }">
                <el-form label-width="100px" ref="formData" :model="form" style="margin: 30px 0 0 0" :rules="formRules">
                  <el-card class="form-section" shadow="hover">
                    <template #header>
                      <div class="section-header">
                        <i class="el-icon-document-add"></i>
                        <span>投稿区域</span>
                      </div>
                    </template>
                    <el-form-item label="稿件标题" prop="title" :rules="[
                      {
                        required: true,
                        min: 5,
                        max: 100,
                        message: '长度在 5 到 100个字符',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input placeholder="请填入正确的文章标题，后续将自动填入用稿通知" v-model="form.title"></el-input>
                    </el-form-item>

                    <el-form-item :label="'投稿' + subName" prop="subjectId" :rules="[
                      {
                        required: true,
                        message: '请选择',
                        trigger: 'change',
                      },
                    ]">
                      <el-select placeholder="请选择" v-model="form.subjectId">
                        <el-option v-for="item in subjects" :key="item.subjectId" :label="item.name"
                          :value="item.subjectId"> </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="稿件附件" prop="attachCode" :rules="[
                      {
                        required: true,
                        message: '稿件附件必须上传',
                        trigger: 'change',
                      },
                    ]">
                      <el-upload ref="fileUpload" v-model="form.attachCode" :action="uploadURL"
                        :before-upload="uploadBefore" :multiple="false" name="file" list-type="text"
                        :file-list="uploadFilelist" :limit="1" :headers="uploadHeaders" :on-exceed="uploadExceed"
                        :on-success="uploadSuccess" :on-remove="uploadRemove"
                        accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                        <el-button size="small" type="primary"> 点击选择文件并上传… </el-button>
                        <div slot="tip" class="el-upload__tip">只能上传docx文件，且不超过50MB</div>
                      </el-upload>
                    </el-form-item>
                  </el-card>

                  <el-card class="form-section" shadow="hover">
                    <template #header>
                      <div class="section-header">
                        <i class="el-icon-document-add"></i>
                        <span>作者信息</span>
                      </div>
                    </template>
                    <el-form-item label="稿件作者" prop="author" :rules="[
                      {
                        required: true,
                        message: '必须填写所有作者姓名',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input v-model="form.author" placeholder="请填入所有作者姓名，后续将自动填入用稿通知"
                        style="width: 360px"></el-input>
                      <br />
                      <span></span>
                      <!--el-checkbox v-model="form.authorSync">同步到我的资料</el-checkbox-->
                    </el-form-item>

                    <el-form-item label="联系电话" prop="telephone">
                      <el-input v-model="form.telephone" placeholder="填写手机号码，否则无法接收短信" style="width: 360px"></el-input>
                      <!--br />
                    <el-checkbox v-model="form.telephoneSync">同步到我的联系电话</el-checkbox-->
                    </el-form-item>

                    <el-form-item label="电子邮箱" prop="email">
                      <el-input placeholder="" v-model="form.email" style="width: 360px"></el-input>
                    </el-form-item>

                    <el-form-item label="工作单位" prop="company" :rules="[
                      {
                        required: true,
                        max: 30,
                        message: '不超过30个字符',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input placeholder="" v-model="form.company"></el-input>
                      <!--br />
                    <el-checkbox v-model="form.companySync">同步到我的资料</el-checkbox-->
                    </el-form-item>

                    <el-form-item label="邮政编码" prop="postal" :rules="[
                      {
                        required: true,
                        message: '邮政编码必须填写',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input placeholder="" v-model="form.postal"></el-input>
                    </el-form-item>

                    <el-form-item label="作者简介" prop="desc" :rules="[
                      {
                        required: true,
                        max: 200,
                        message: '作者简介格式：姓名（出生年—），性别，籍贯，学历，职称，研究方向。',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input v-model="form.desc" type="textarea" placeholder="作者简介格式：姓名（出生年—），性别，籍贯，学历，职称，研究方向。"
                        rows="6"></el-input>
                      <!--br />
                    <el-checkbox v-model="form.descSync">同步到我的资料</el-checkbox-->
                    </el-form-item>
                  </el-card>

                  <el-card class="form-section" shadow="hover">
                    <template #header>
                      <div class="section-header">
                        <i class="el-icon-document-add"></i>
                        <span>收件设置</span>
                      </div>
                    </template>

                    <el-form-item label="收件地址" prop="address" :rules="[
                      {
                        required: true,
                        message: '请填入详细收件地址，涉及纸质刊物邮寄',
                        trigger: 'blur',
                      },
                    ]">
                      <el-input placeholder="请填入详细收件地址，涉及纸质刊物邮寄" v-model="form.address"></el-input>
                    </el-form-item>
                  </el-card>

                  <div style="text-align: center">
                    <el-button type="primary" size="default" :disabled="status != 0" @click="submit">{{ btnText
                    }}</el-button>
                  </div>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>

      <!--投稿成功结果-->
      <el-row v-show="step == 2">
        <el-col :span="24">
          <div class="box">
            <div class="header">
              <h3>论文投稿</h3>
            </div>
            <div class="content">
              <div class="info">
                <div class="success">
                  <i class="el-icon el-icon-circle-check"></i>
                  投稿成功！
                </div>
                <div class="txt desc">等待编辑部审稿，请持续关注系统信息和手机短信信息！</div>
                <div class="txt">
                  <el-button type="default" @click="gotoStep(1, true)">继续投稿</el-button>
                  <el-button type="default" @click="gotoMyArticlePage()">查看投稿稿件</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import settingApi from "@/api/setting"
import subjectApi from "@/api/subject"
import personApi from "@/api/person"
import authorApi from "@/api/author"
import http from "@/api/http"
import { getToken } from "@/utils/auth"

import { MessageBox } from "element-ui"

export default {
  name: "ArticleAdd",
  components: { PageHeader },
  data() {
    // 验证邮箱的规则
    var checkEmail = (rules, value, cb) => {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      if (regEmail.test(value)) {
        return cb()
      }
      cb(new Error("请输入合法的邮箱"))
    }
    // 验证手机号的规则
    var checkMobile = (rules, value, cb) => {
      const regMobile = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error("请输入合法的手机号"))
    }

    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      steps: [],
      step: 0,
      headLinks: [{ path: "", title: "立即投稿" }],
      noticeHtml: "",
      subjects: [],

      status: 0,

      btnText: "确认投稿",
      form: {
        title: "",
        subjectId: null,
        email: "",
        address: "",
        postal: "",
        attachId: 0,
        attachCode: "",
        author: "",
        authorSync: true,
        telephone: "",
        telephoneSync: true,
        company: "",
        companySync: true,
        desc: "",
        descSync: true,
      },
      uploadFilelist: [],
      uploadURL: "",
      uploadHeaders: { Authorization: getToken() },

      checked: false,
      times: 10,

      formRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
      },
    }
  },

  watch: {
    btnText() {
      if (this.status == 0) return "确认投稿"
      else if (this.status == 1) return "正在提交中"
      else return "投稿完成"
    },
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "attach/uploadArticle"
  },

  mounted() {
    this.initSetting()
  },

  methods: {
    uploadBefore(file) {
      //const isDOC = file.type === "application/msword"
      const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      const isLt5M = file.size / 1024 / 1024 < 50

      if (!isDOCX) {
        this.$alert("文件必须是扩展名为“DOCX”的文档", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      if (!isLt5M) {
        this.$alert("文件不能超过 50MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return isDOCX && isLt5M
    },

    uploadExceed() {
      this.$alert("只能上传一个文件，请删除后再上传", "异常提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("上传失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
        this.$refs.fileUpload.clearFiles()
      } else {
        this.form.attachId = res.data.attachId
        this.form.attachCode = res.data.attachCode
        this.$refs.formData.validateField("attachCode")
      }
    },

    uploadRemove() {
      authorApi.myArticleRemoveFile(this.form.attachId, this.form.attachCode).then((res) => {
        console.log(res)
      })
    },

    /*初始化 */
    initSetting() {
      if (process.env.VUE_APP_PLATFORM == "cxzw") {
        this.steps = this.$config.stepBasic
      } else {
        this.steps = this.$config.stepCharge
      }

      settingApi.getNotice().then((res) => {
        this.noticeHtml = res.data
        this.steps[0].status = "process"

        this.times = 10
        this.timer = setInterval(() => {
          this.times--
          if (this.times === 0) {
            //this.show = true
            clearInterval(this.timer)
          }
        }, 1000)
      })
    },

    /**
     * steps组件跳转业务处理
     * @param step :第几个步骤，从0开始计算
     * @param cz : 是否重置表单，true为重置表单
     */
    gotoStep(step, cz) {
      //检查是否勾选了复选框
      if (!this.checked) {
        MessageBox.alert("请勾选左侧的“接受该须知”", "系统提示", {
          confirmButtonText: "确定",
          showClose: false,
          callback: () => {
            //Router.push("/login").catch(() => {});
          },
        })
        return false
      }

      this.step = step
      if (step == 1) {
        this.steps[0].status = "finish"
        //window.scrollTo(0, 0);

        //进行初始化
        this.loadSubjectAndUser()
        this.form.title = ""
        this.form.subjectId = null
        this.status = 0
        this.uploadFilelist = []
        if (cz) {
          this.$refs.formData.resetFields()
        }

        // 确保DOM更新后再执行滚动操作
        this.$nextTick(() => {
          this.$refs.addBox.scrollIntoView({
            behavior: 'smooth', // 平滑滚动（可选）
            block: 'start'      // 顶部对齐
          });
        });

      } else if (step == 2) {
        this.steps[0].status = "success"
      }
    },

    /**
     * 加载栏目和作者信息
     */
    loadSubjectAndUser() {
      let p1 = subjectApi.getAll().then((res) => {
        this.subjects = res.data
      })

      let p2 = personApi.getInfo().then((res) => {
        this.form.company = res.data.workUnit
        //this.form.author = res.data.userName;
        //this.form.telephone = res.data.telephone;
        this.form.desc = res.data.synopsis
      })

      Promise.all([p1, p2]).then(() => {
        //console.log()
      })
    },

    /**
     * 提交表单
     */
    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.status = 1
          authorApi.myArticleAdd(this.form).then((res) => {
            if (res.code == 0) {
              this.status = 2
              //console.log(this)
              this.getStat()
              this.gotoStep(2, false)
            }
          })
        }
      })
    },

    gotoMyArticlePage() {
      //Router.push("/login").catch(() => {});
      this.$router.push("/article/myArticleRunning")
    },

    /* getStat() {
      systemApi.getStat().then((res) => {
        if (res.code == 0) {
          this.$store.commit("app/SET_AUTHORSTAT", res.data.authorHomeInfoVO);
          this.$store.commit("app/SET_FINANCESTAT", res.res.data.financeHomeInfoVO);
        }
      })
    }, */
  },
}
</script>

<style lang="scss" scoped>
/*进入前和结束后的状态*/
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(80px);
}

/*进入和离开的动画时间段*/
.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}

.box {
  margin: 30px;
  height: 100%;
  padding: 15px;
  border: 1px solid #ccc;

  .header {
    line-height: 44px;
    height: 60px;

    h3 {
      display: none;
    }
  }
}

.el-card {
  margin-bottom: 20px;
}

@media screen and (min-width: 768px) {
  box {
    margin: 30px;
  }
}

.info {
  margin: auto;
  width: 400px;
  min-height: 300px;
  text-align: center;
}

.success {
  text-align: center;
  font-size: 36px;
  color: #52c011;
  margin: 40px 0;
}

.txt {
  margin: 20px 0 0 0;
}
</style>
